import Sider from "antd/es/layout/Sider";
import styled from "styled-components";
import { secondaryColor, thirdColor } from "../../../config";

export const Wrapper = styled(Sider)`
.menu-sub-dropdown { display: block;}

`;
export const ProfileView = styled.div`
.menu-sub-dropdown { display: block;}
  
`;

export const MenuView = styled.div`
.ant-menu-inline .ant-menu-item,
.ant-menu-vertical .ant-menu-item,
.ant-menu-inline .ant-menu-submenu-title,
.ant-menu-vertical .ant-menu-submenu-title {
    margin-inline: 0px;
    margin-block: 4px;
    width: calc(100% - 0px);
}

.ant-menu-title-content span,
.ant-menu-title-content {
    font-size: 1.1rem;
    font-weight: 600;
}

.ant-menu-item,
.ant-menu-submenu-title {
    padding-left: 15px !important;
}

.ant-menu-item-icon {
    color: #f45b68 !important;
}

/* Shared selected state (light + dark) */
.ant-menu-light .ant-menu-item-selected,
.ant-menu-light > .ant-menu .ant-menu-item-selected,
.ant-menu-dark .ant-menu-item-selected,
.ant-menu-dark > .ant-menu .ant-menu-item-selected {
    background-color: #f45b68 !important;
    color: #ffffff !important;
}

.ant-menu-light .ant-menu-item-selected i,
.ant-menu-light > .ant-menu .ant-menu-item-selected i,
.ant-menu-dark .ant-menu-item-selected i,
.ant-menu-dark > .ant-menu .ant-menu-item-selected i {
    color: #fff !important;
}

.ant-menu-light .ant-menu-item-selected .menu-bullet .bullet,
.ant-menu-light > .ant-menu .ant-menu-item-selected .menu-bullet .bullet,
.ant-menu-dark .ant-menu-item-selected .menu-bullet .bullet,
.ant-menu-dark > .ant-menu .ant-menu-item-selected .menu-bullet .bullet {
    background-color: #fff;
}

.ant-menu-light.ant-menu-root.ant-menu-inline,
.ant-menu-light > .ant-menu.ant-menu-root.ant-menu-inline,
.ant-menu-light.ant-menu-root.ant-menu-vertical,
.ant-menu-light > .ant-menu.ant-menu-root.ant-menu-vertical,
.ant-menu-dark.ant-menu-root.ant-menu-inline,
.ant-menu-dark > .ant-menu.ant-menu-root.ant-menu-inline,
.ant-menu-dark.ant-menu-root.ant-menu-vertical,
.ant-menu-dark > .ant-menu.ant-menu-root.ant-menu-vertical {
    border-inline-end: 1px solid transparent;
    background: transparent !important;
}

/* Light sidebar hover */
.ant-menu-light:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):hover,
.ant-menu-light > .ant-menu:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):hover {
    background-color: #181c32;
}
.ant-menu-light:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):hover .ant-menu-title-content,
.ant-menu-light > .ant-menu:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):hover .ant-menu-title-content {
    color: #fff;
}
.ant-menu-light:not(.ant-menu-horizontal) .ant-menu-submenu-title:hover,
.ant-menu-light > .ant-menu:not(.ant-menu-horizontal) .ant-menu-submenu-title:hover {
    background-color: #181c32;
}
.ant-menu-light:not(.ant-menu-horizontal) .ant-menu-submenu-title:hover .ant-menu-title-content,
.ant-menu-light > .ant-menu:not(.ant-menu-horizontal) .ant-menu-submenu-title:hover .ant-menu-title-content {
    color: #fff;
}
.ant-menu-light:not(.ant-menu-horizontal) .ant-menu-submenu-title:hover .ant-menu-submenu-arrow,
.ant-menu-light > .ant-menu:not(.ant-menu-horizontal) .ant-menu-submenu-title:hover .ant-menu-submenu-arrow {
    color: #fff;
}

/* Dark sidebar hover — match Keen sidebar surface */
.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):hover,
.ant-menu-dark > .ant-menu:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):hover {
    background-color: #2b2b40 !important;
}
.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):hover .ant-menu-title-content,
.ant-menu-dark > .ant-menu:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):hover .ant-menu-title-content {
    color: var(--app-text) !important;
}
.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-submenu-title:hover,
.ant-menu-dark > .ant-menu:not(.ant-menu-horizontal) .ant-menu-submenu-title:hover {
    background-color: #2b2b40 !important;
}
.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-submenu-title:hover .ant-menu-title-content,
.ant-menu-dark > .ant-menu:not(.ant-menu-horizontal) .ant-menu-submenu-title:hover .ant-menu-title-content,
.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-submenu-title:hover .ant-menu-submenu-arrow,
.ant-menu-dark > .ant-menu:not(.ant-menu-horizontal) .ant-menu-submenu-title:hover .ant-menu-submenu-arrow {
    color: var(--app-text) !important;
}

.ant-menu-dark .ant-menu-item,
.ant-menu-dark .ant-menu-submenu-title,
.ant-menu-dark .ant-menu-title-content {
    color: var(--app-text-muted);
}

.ant-menu-dark .ant-menu-submenu-open.ant-menu-submenu-selected .ant-menu-submenu-title .ant-menu-title-content,
.ant-menu-dark .ant-menu-submenu-open.ant-menu-submenu-selected .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-menu-light .ant-menu-submenu-open.ant-menu-submenu-selected .ant-menu-submenu-title .ant-menu-title-content,
.ant-menu-light .ant-menu-submenu-open.ant-menu-submenu-selected .ant-menu-submenu-title .ant-menu-submenu-arrow {
    color: var(--app-text) !important;
}
.ant-menu-light.ant-menu-inline .ant-menu-sub.ant-menu-inline, .ant-menu-light>.ant-menu.ant-menu-inline .ant-menu-sub.ant-menu-inline {
    background: rgba(0, 0, 0, 0.00);
}
.ant-menu-dark.ant-menu-inline .ant-menu-sub.ant-menu-inline, .ant-menu-dark>.ant-menu.ant-menu-inline .ant-menu-sub.ant-menu-inline {
    background: transparent;
}
.ant-menu-dark .ant-menu-item-selected a, .ant-menu-dark>.ant-menu .ant-menu-item-selected a, .ant-menu-dark .ant-menu-item-selected a:hover, .ant-menu-dark>.ant-menu .ant-menu-item-selected a:hover {
    color: #fff;
}

/* AI Copilot — Beta tag (sidebar) */
.sidebar-beta-tag {
    margin-left: 6px;
    padding: 1px 6px;
    font-size: 11px !important;
    font-weight: 700;
    line-height: 1.4;
    letter-spacing: 0.4px;
    border-radius: 4px;
    // text-transform: uppercase;
    vertical-align: middle;
    color: var(--app-text);
    background: color-mix(in srgb, var(--app-text) 8%, transparent);
    border: 1px solid color-mix(in srgb, var(--app-text) 22%, transparent);
}

.ant-menu-light:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):hover .sidebar-beta-tag,
.ant-menu-light > .ant-menu:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):hover .sidebar-beta-tag {
    color: #fff !important;
    background: rgba(255, 255, 255, 0.22) !important;
    border-color: rgba(255, 255, 255, 0.5) !important;
}

.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):hover .sidebar-beta-tag,
.ant-menu-dark > .ant-menu:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):hover .sidebar-beta-tag {
    color: var(--app-text) !important;
    background: color-mix(in srgb, var(--app-text) 14%, transparent) !important;
    border-color: color-mix(in srgb, var(--app-text) 28%, transparent) !important;
}

.ant-menu-item-selected .sidebar-beta-tag {
    color: #fff !important;
    background: rgba(255, 255, 255, 0.22) !important;
    border-color: rgba(255, 255, 255, 0.65) !important;
}

/* Submenu — tree hierarchy (matches P&L Tax paid breakdown) */
&:not(.collapsed) {
    .ant-menu-submenu-open .ant-menu-sub.ant-menu-inline {
        position: relative;
        background: transparent !important;
        margin: 0 0 4px 32px;
        padding: 0 0 0 12px;
        border-left: none;
    }

    /* Continuous vertical trunk */
    .ant-menu-submenu-open .ant-menu-sub.ant-menu-inline::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        height: calc(100% - 17px);
        border-left: 1.5px solid rgba(244, 91, 104, 0.35);
        pointer-events: none;
    }

    .sidebar-submenu-item {
        position: relative;
        height: 34px !important;
        line-height: 34px !important;
        margin-block: 0 !important;
        padding-left: 8px !important;
        padding-inline-start: 8px !important;
        border-radius: 6px !important;
        overflow: visible !important;
    }

    /* Horizontal branch from trunk to label */
    .sidebar-submenu-item::before {
        content: "";
        position: absolute;
        left: -12px;
        top: 50%;
        width: 12px;
        height: 0;
        border-top: 1.5px solid rgba(244, 91, 104, 0.35);
        pointer-events: none;
    }

    .sidebar-submenu-item::after {
        display: none;
    }

    .sidebar-submenu-item .ant-menu-title-content,
    .sidebar-submenu-item .sidebar-menu-label {
        font-size: 1.04rem !important;
        font-weight: 500 !important;
        color: var(--app-text-muted) !important;
    }

    .ant-menu-light:not(.ant-menu-horizontal) .sidebar-submenu-item:not(.ant-menu-item-selected):hover .sidebar-menu-label,
    .ant-menu-light > .ant-menu:not(.ant-menu-horizontal) .sidebar-submenu-item:not(.ant-menu-item-selected):hover .sidebar-menu-label {
        color: #fff !important;
    }

    .sidebar-submenu-item.ant-menu-item-selected .sidebar-menu-label {
        color: #fff !important;
        font-weight: 600 !important;
    }
}
`;